import { cruiseConfig } from '@/config/cruise';
import { mapControlClassName } from '@/utils/map';
import { ControlPosition, MapControl } from '@vis.gl/react-google-maps';
import classes from './back-to-overview-control.module.css';

/**
 * @returns {React.JSX.Element | undefined}
 */
export function BackToOverviewControl() {
  return cruiseConfig.overviewUrl ? (
    <MapControl position={ControlPosition.TOP_LEFT}>
      <a href={cruiseConfig.overviewUrl} className={`${mapControlClassName} ${classes.btnBack}`}>
        {'<'} Back to Overview
      </a>
    </MapControl>
  ) : undefined;
}
